/**
 * FocusAreaChips — chip multi-select for "what should the verifier focus on?"
 * Used in Screen 2 of the booking wizard.
 *
 * Free-text "Anything specific?" lives on Screen 1 as the AI-powered
 * description field (AIDescriptionField), so this component is now just
 * the chip picker.
 */

import React from 'react';
import { Box, Chip, Typography, Stack } from '@mui/material';
import { colors } from '../../theme/colors';

const DEFAULT_AREAS = [
  'Roof',
  'Plumbing',
  'Cracks',
  'Security',
  'Garden',
  'Furniture',
  'Appliances',
  'Electrical',
  'Damp / mould',
];

const FocusAreaChips = ({ areas = [], onChange }) => {
  const toggle = (area) => {
    const next = areas.includes(area) ? areas.filter((a) => a !== area) : [...areas, area];
    onChange(next);
  };

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Focus areas (optional)
      </Typography>

      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {DEFAULT_AREAS.map((area) => {
          const selected = areas.includes(area);
          return (
            <Chip
              key={area}
              label={area}
              onClick={() => toggle(area)}
              variant={selected ? 'filled' : 'outlined'}
              sx={{
                cursor: 'pointer',
                fontWeight: selected ? 600 : 500,
                borderColor: selected ? colors.brand.primary : undefined,
                bgcolor: selected ? colors.brand.primary : 'transparent',
                color: selected ? '#fff' : 'text.primary',
                '&:hover': {
                  bgcolor: selected ? colors.brand.primaryDark : 'rgba(13,148,136,0.06)',
                },
              }}
            />
          );
        })}
      </Stack>
    </Box>
  );
};

export default FocusAreaChips;
